module.exports = __webpack_public_path__ + "img/object_remove_icon_2.c95a7c4b.webp";